import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Collapse } from '@chakra-ui/react';
import { ChevronDownIcon, DashedLineIcon, DateIcon, DeleteIcon, EditIcon } from '@sketchnote/icons';
import { Avatar, MoreActionMenu } from '@sketchnote/shared-components';
// import { Button } from '@sketchnote/shared-components';
import cn from 'classnames';
import * as React from 'react';
import { useState } from 'react';
// import { API } from 'src/api';
import { calculateTimeInHours } from 'src/utils/date-time-functions';

import { LogItem, LogUser, useTimesheetStore } from '../store/useTimesheetStore';
import { EditTimelog } from './EditTimelog';
import { formatDateLight } from './Timesheet';

export const TimesheetUser = ({
  showLog,
  taskKey,
  assignDate,
  logUser,
}: {
  showLog: boolean;
  taskKey: string;
  assignDate: string[] | undefined;
  logUser: LogUser;
}) => {
  const [selectedUser, setSelectedUser] = useState(0);
  const [collapse, setCollapse] = useState(false);

  let userTotalTimeTracked = 0;

  const getTotalTimeTracked = (logs: LogUser['logs']): string => {
    if (logs?.length > 0) {
      for (const item of logs) {
        let total = 0;
        if (item) {
          total +=
            parseInt(item?.duration?.hours || '0') * 60 + parseInt(item?.duration?.minutes || '0');
        }
        userTotalTimeTracked += total;
      }
    }
    if (userTotalTimeTracked !== 0)
      return calculateTimeInHours({ time: userTotalTimeTracked, format: 'string' });
    else return '';
  };

  const getBillableHours = (logs: LogUser['logs']): { billable: string; nonBillable: string } => {
    let billable = '',
      nonBillable = '';
    let billableHours = 0;
    let nonbillableHours = 0;
    if (logs?.length) {
      for (const item of logs) {
        if (item.billable) {
          billableHours +=
            parseInt(item?.duration?.hours || '0') * 60 + parseInt(item?.duration?.minutes || '0');
        } else {
          nonbillableHours +=
            parseInt(item?.duration?.hours || '0') * 60 + parseInt(item?.duration?.minutes || '0');
        }
      }
    }
    if (billableHours !== 0)
      billable = calculateTimeInHours({ time: billableHours, format: 'string' });
    if (nonbillableHours !== 0)
      nonBillable = calculateTimeInHours({ time: nonbillableHours, format: 'string' });

    return { billable, nonBillable };
  };

  const timeTrackedStr = getTotalTimeTracked(logUser.logs);
  const { billable, nonBillable } = getBillableHours(logUser.logs);

  return (
    <>
      <div className="w-full pr-20 bg-gray-100">
        <div
          style={{
            boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)',
            border: '1px solid #EDEDED',
          }}
          className="flex flex-row items-center rounded-md w-full"
          onClick={(e) => {
            setCollapse(!collapse);
          }}
        >
          <div className="flex flex-col">
            <div className="flex w-full h-40 items-center">
              <div role="button" className="flex items-center justify-between">
                <div className="">
                  <span
                    style={{
                      transform: collapse && showLog ? 'rotate(0deg)' : 'rotate(-90deg)',
                      transition: 'all 0.5s',
                    }}
                    className={'ml-20 mr-6 block text-gray-500'}
                    onClick={(e) => {
                      setCollapse(!collapse);
                    }}
                  >
                    <ChevronDownIcon />
                  </span>
                </div>
              </div>
              <div className="flex w-172"></div>

              <div className="flex w-172 ">
                <div className={cn('text-xs font-medium pt-4 truncate text-gray-500')}>
                  {taskKey}
                </div>
              </div>
              <div className="w-172">
                <span className="mt-2 text-xs text-gray-500">
                  {assignDate?.length ? (
                    <span className="mt-2 text-xs text-gray-500">
                      <span className="leading-22">{formatDateLight(assignDate)}</span>
                    </span>
                  ) : (
                    <DateIcon wrapperClass="border-2 border-gray-400 text-gray-400 border-dotted p-5 rounded-full" />
                  )}
                </span>
              </div>
              <div className="flex w-172">
                <>
                  <Avatar
                    name={cn(logUser.firstname, logUser.lastname)}
                    tooltip={false}
                    type="photo"
                    src={logUser.avatar}
                    wrapperClassName="border-white border-2 transform transition duration-500 hover:scale-125"
                  />
                </>
              </div>
              {logUser.estimate !== undefined ? (
                <div className="flex pr-5 text-gray-500 text-xs font-medium w-172 ">
                  {logUser.estimate}
                </div>
              ) : (
                <div className="flex w-172">
                  <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
                </div>
              )}
              {timeTrackedStr !== '' ? (
                <div className="flex pr-5 w-172 text-gray-500 text-xs font-medium">
                  {timeTrackedStr}
                </div>
              ) : (
                <div className="flex w-172">
                  <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
                </div>
              )}
              {nonBillable !== '' ? (
                <div className="flex pr-5 w-172 text-gray-500 text-xs font-medium">
                  {nonBillable}
                </div>
              ) : (
                <div className="flex min-w-172">
                  <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
                </div>
              )}
              {billable !== '' ? (
                <div className="flex pr-5 w-172 text-gray-500 text-xs font-medium">{billable}</div>
              ) : (
                <div className="flex w-172">
                  <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
                </div>
              )}
            </div>
            {showLog && logUser.logs?.length ? (
              <div
                className={cn({
                  'mx-15 text-gray-500 text-xss min-w-172': true,
                  'pb-23': collapse,
                })}
              >
                <div className="flex flex-col">
                  {logUser.logs?.map((item, index) => {
                    return (
                      <Collapse in={collapse} className="" key={index} style={{ overflow: 'auto' }}>
                        <div
                          className="mb-8"
                          onClick={(e) => {
                            setSelectedUser(index);
                          }}
                        >
                          {<TimesheetLog key={index} logItem={item} logUser={logUser} />}
                        </div>
                      </Collapse>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export const TimesheetLog = ({ logItem, logUser }: { logItem: LogItem; logUser: LogUser }) => {
  const [isDeletePromptOpen, setIsDeletePromptOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const { deleteTimeLogEntry } = useTimesheetStore();

  const handleMenuItemClick = (e) => {
    if (e.value === 'delete') {
      setIsDeletePromptOpen(true);
    } else if (e.value === 'edit') {
      setIsEditOpen(true);
    }
  };
  const handleDeleteLogEntry = async () => {
    const response = await deleteTimeLogEntry(logItem._id);
    setIsDeletePromptOpen(false);
  };

  return (
    <>
      <div className="flex flex-row items-center justify-center">
        <div className="flex w-172 ml-40"></div>
        <div className="flex w-172"></div>
        <div className="flex w-172"></div>
        <div className="flex flex-row text-gray-300 items-center">
          <div className="">
            <DashedLineIcon wrapperClass="" />
          </div>
          <div className="flex min-w-132 pt-24 pl-5 mr-1">
            {formatDateLight([logItem?.startDate])}
          </div>
          <div className="flex w-172 pt-24">
            <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
          </div>
          <div className="flex text-gray-500 pt-24 text-xss font-medium w-172">
            {logItem?.duration?.minutes
              ? `${logItem?.duration?.hours}h ${logItem?.duration?.minutes}m`
              : `${logItem?.duration?.hours}h`}
          </div>
          {!logItem.billable ? (
            <div className="flex pr-5 text-gray-500 pt-24 text-xss font-medium w-172">
              {logItem?.duration?.minutes
                ? `${logItem?.duration?.hours}h ${logItem?.duration?.minutes}m`
                : `${logItem?.duration?.hours}h`}
            </div>
          ) : (
            <div className="flex w-172 pt-24">
              <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
            </div>
          )}
          {logItem.billable ? (
            <div className="flex pr-5 text-gray-500 pt-24 text-xss font-medium min-w-177">
              {logItem?.duration?.minutes
                ? `${logItem?.duration?.hours}h ${logItem?.duration?.minutes}m`
                : `${logItem?.duration?.hours}h`}
            </div>
          ) : (
            <div className="flex min-w-177 pt-24">
              <div className="bg-gray-500 w-12 h-4 rounded-sm my-auto" />
            </div>
          )}
        </div>
        <div className="flex pt-24">
          <div className="self-end items-end pb-4 text-gray-400 border-gray-100 ">
            <MoreActionMenu
              onClickMenuItem={handleMenuItemClick}
              classNames={{
                menuWrap: 'rounded-lg shadow-sm',
              }}
              menuItems={[
                {
                  label: (
                    <div className="font-regular text-gray-999 text-sm ">
                      <EditIcon wrapperClass="mt-4 text-gray-500" />
                      &nbsp;&nbsp; Edit entry
                    </div>
                  ),
                  value: 'edit',
                },
                {
                  label: (
                    <div className="flex font-regular text-gray-999 text-sm ">
                      <DeleteIcon wrapperClass="mt-4 text-gray-500" />
                      &nbsp;&nbsp; Delete
                    </div>
                  ),
                  value: 'delete',
                },
              ]}
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={isDeletePromptOpen}
        onClose={() => {
          setIsDeletePromptOpen(false);
        }}
      >
        <ModalOverlay />

        <ModalContent
          style={{
            maxWidth: '46rem',
            padding: '32px',
            marginTop: '20rem',
            borderRadius: '8px',
          }}
        >
          <ModalCloseButton />
          <p className="mb-32 text-md text-gray-999">Are you sure you wish to proceed?</p>
          <div className="flex justify-end">
            <button
              onClick={() => {
                setIsDeletePromptOpen(false);
              }}
              className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
            >
              Cancel
            </button>
            <button
              className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
              onClick={handleDeleteLogEntry}
            >
              Delete
            </button>
          </div>
        </ModalContent>
      </Modal>

      {/* Edit Entry */}
      <Modal
        isOpen={isEditOpen}
        onClose={() => {
          setIsEditOpen(false);
        }}
      >
        <ModalOverlay />
        <ModalContent
          style={{
            maxWidth: '40rem',
            maxHeight: '40rem',
            marginTop: '20rem',
            borderRadius: '6px',
          }}
        >
          <EditTimelog
            logItem={logItem}
            logUser={logUser}
            onCloseModal={() => {
              setIsEditOpen(false);
            }}
            onDeleteLogEntry={handleDeleteLogEntry}
          />
        </ModalContent>
      </Modal>
    </>
  );
};
